/* =====================================================================
   POPUP PHOTOS — fiche produit (pc-lightbox)

   Se greffe sur la galerie de pc-product ([data-gallery-main]) sans
   toucher au Liquid : il relit les <img> des .g-slide.
   Facultatif : data-zoom-src + data-zoom-w sur la .g-slide (le plus
   grand carré que le CDN sait servir pour cette photo). Sinon, le plus
   grand candidat du srcset de la galerie sert aussi au zoom.

   Rien n'est ajouté sur la page : un simple toucher sur la photo ouvre.
   Dans le popup, rien que les photos et la croix pour fermer.

   Ouvrir  : toucher / clic sur la photo, Entrée sur la galerie.
   Glisser : doigt, molette, glisser à la souris, ← → au clavier,
             flèches (ordinateur seulement).
   Zoomer  : double toucher ou pincement ; clic (loupe) à la souris.
   Fermer  : ×, Échap, toucher le flou, glisser vers le bas, retour
             arrière du téléphone.
   ===================================================================== */
(function () {
  'use strict';

  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mm = function (m) { return window.matchMedia ? window.matchMedia(m) : { matches: false }; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var REDUCED = mm('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var ZOOM_MOUSE = 2.2, ZOOM_TAP = 2.6, ZOOM_MAX = 4;

  var SVG = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
  };
  var ICON = { close: SVG('M6 6l12 12M18 6L6 18'), prev: SVG('M15 5l-7 7 7 7'), next: SVG('M9 5l7 7-7 7') };

  function innerRadius(el) {
    var cs = getComputedStyle(el);
    return Math.max(0, (parseFloat(cs.borderTopLeftRadius) || 0) - (parseFloat(cs.borderTopWidth) || 0));
  }

  function inView(r) {
    return r && r.width > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }

  function ready(img, ms) {
    return new Promise(function (done) {
      if (img.complete && img.naturalWidth) return done();
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(done, ms);
    });
  }

  /* La copie volante : posée à l'ARRIVÉE, elle part du rectangle de
     départ par un transform — seul le compositeur travaille. */
  function fly(src, from, to, r0, r1, ms) {
    var g = new Image();
    g.className = 'pc-lb-ghost';
    g.alt = '';
    g.src = src;
    g.style.cssText = 'left:' + to.left + 'px;top:' + to.top + 'px;width:' + to.width + 'px;height:' + to.height + 'px';
    document.body.appendChild(g);
    var sx = from.width / to.width, sy = from.height / to.height;
    var anim = g.animate([
      { transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + sx + ',' + sy + ')',
        borderRadius: (r0 / sx) + 'px / ' + (r0 / sy) + 'px' },
      { transform: 'none', borderRadius: r1 + 'px' }
    ], { duration: ms, easing: EASE, fill: 'both' });
    return { el: g, anim: anim };
  }

  function initLightbox() {
    var main = q('[data-gallery-main]');
    if (!main || main.pcLb) return;
    var gSlides = qa('.g-slide', main).filter(function (s) { return q('img', s); });
    if (!gSlides.length) return;
    main.pcLb = true;

    var title = ((q('.buybox h1') || {}).textContent || document.title).trim();
    var items = gSlides.map(function (s) {
      var im = q('img', s);
      var set = im.getAttribute('srcset') || '';
      var zs = s.getAttribute('data-zoom-src') || im.getAttribute('data-zoom-src');
      var zw = s.getAttribute('data-zoom-w') || im.getAttribute('data-zoom-w');
      if (zs && zw) set += (set ? ', ' : '') + zs + ' ' + zw + 'w';
      return { src: im.getAttribute('src'), srcset: set, alt: im.alt || title };
    });

    var root, card, scrim, stage, track, prevBtn, nextBtn;
    var slides = [];
    var i = 0, marked = false, isOpen = false, lastFocus = null, pushed = false, inerted = [];
    var z = { s: 1, x: 0, y: 0, slide: null, loupe: false };

    /* ---------- Construction (au premier appel) ---------------------- */
    function build() {
      if (root) return;
      root = document.createElement('div');
      root.className = 'pc-lb';
      root.hidden = true;
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-label', 'Photos — ' + title);
      root.innerHTML =
        '<div class="pc-lb__scrim" data-lb-close></div>' +
        '<div class="pc-lb__card">' +
          '<div class="pc-lb__stage">' +
            '<div class="pc-lb__track" tabindex="-1"></div>' +
            '<button type="button" class="pc-lb__btn pc-lb__close" data-lb-close aria-label="Fermer">' + ICON.close + '</button>' +
            '<button type="button" class="pc-lb__btn pc-lb__arrow pc-lb__arrow--prev" data-lb-prev aria-label="Photo précédente">' + ICON.prev + '</button>' +
            '<button type="button" class="pc-lb__btn pc-lb__arrow pc-lb__arrow--next" data-lb-next aria-label="Photo suivante">' + ICON.next + '</button>' +
          '</div>' +
        '</div>';
      scrim = q('.pc-lb__scrim', root);
      card = q('.pc-lb__card', root);
      stage = q('.pc-lb__stage', root);
      track = q('.pc-lb__track', root);
      prevBtn = q('[data-lb-prev]', root);
      nextBtn = q('[data-lb-next]', root);

      items.forEach(function (it, k) {
        var fig = document.createElement('figure');
        fig.className = 'pc-lb__slide';
        fig.setAttribute('data-k', k);
        fig.setAttribute('aria-label', 'Photo ' + (k + 1) + ' sur ' + items.length);
        var wrap = document.createElement('div');
        wrap.className = 'pc-lb__zoom';
        var img = document.createElement('img');
        img.alt = it.alt;
        img.decoding = 'async';
        img.draggable = false;
        img.addEventListener('load', function () { img.classList.add('is-ready'); });
        wrap.appendChild(img);
        fig.appendChild(wrap);
        track.appendChild(fig);
        slides.push({ el: fig, zoom: wrap, img: img, loaded: false });
      });

      document.body.appendChild(root);
      bind();
    }

    /* ---------- Images : taille demandée = taille affichée ----------- */
    function sizesFor(scale) {
      var w = slides[i] ? slides[i].el.clientWidth : 0;
      return Math.round((w || 600) * (scale || 1)) + 'px';
    }
    function load(k) {
      var s = slides[k];
      if (!s || s.loaded) return;
      s.loaded = true;
      var it = items[k];
      if (it.srcset) { s.img.sizes = sizesFor(1); s.img.srcset = it.srcset; }
      s.img.src = it.src;
      if (s.img.complete && s.img.naturalWidth) s.img.classList.add('is-ready');
    }
    function resize() {
      slides.forEach(function (s) { if (s.loaded) s.img.sizes = sizesFor(1); });
    }

    /* ---------- Position ------------------------------------------- */
    function current() {
      return clamp(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), 0, slides.length - 1);
    }
    function mark(n) {
      if (n === i && marked) return;
      marked = true;
      if (z.slide && z.slide !== slides[n]) resetZoom(true);
      i = n;
      prevBtn.disabled = n === 0;
      nextBtn.disabled = n === slides.length - 1;
      load(n); load(n + 1); load(n - 1);
    }
    function go(n, instant) {
      n = clamp(n, 0, slides.length - 1);
      if (z.slide) resetZoom(!instant);
      track.scrollTo({ left: slides[n].el.offsetLeft, behavior: instant || REDUCED ? 'auto' : 'smooth' });
      mark(n);
    }

    /* ---------- Zoom ----------------------------------------------- */
    function slideAt(target) {
      var el = target && target.closest ? target.closest('.pc-lb__slide') : null;
      return el ? slides[+el.getAttribute('data-k')] : null;
    }
    function setZoom(s, x, y) {
      var w = z.slide.el.clientWidth, h = z.slide.el.clientHeight;
      z.s = s;
      z.x = clamp(x, w - w * s, 0);
      z.y = clamp(y, h - h * s, 0);
      z.slide.zoom.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
      root.classList.toggle('is-zoomed', s > 1.01);
    }
    /* Zoomer en gardant sous le doigt (ou la souris) le point visé. */
    function zoomAt(sl, cx, cy, s, loupe) {
      var r = sl.el.getBoundingClientRect();
      var same = z.slide === sl, s0 = same ? z.s : 1, x0 = same ? z.x : 0, y0 = same ? z.y : 0;
      var px = cx - r.left, py = cy - r.top;
      var ux = (px - x0) / s0, uy = (py - y0) / s0;
      z.slide = sl;
      z.loupe = !!loupe;
      setZoom(s, px - ux * s, py - uy * s);
      sl.img.sizes = sizesFor(s);            /* le navigateur va chercher un fichier plus grand */
      clearTimeout(z.t);
      if (loupe) z.t = setTimeout(function () { if (z.s > 1) root.classList.add('is-loupe'); }, 420);
    }
    function resetZoom(animate) {
      if (!z.slide) return;
      clearTimeout(z.t);
      root.classList.remove('is-loupe');
      if (!animate) root.classList.add('is-gesture');
      z.slide.zoom.style.transform = '';
      z.slide = null;
      z.s = 1; z.x = 0; z.y = 0; z.loupe = false;
      root.classList.remove('is-zoomed');
      if (!animate) { void track.offsetWidth; root.classList.remove('is-gesture'); }
    }
    function loupe(e) {
      var r = z.slide.el.getBoundingClientRect();
      var rx = clamp((e.clientX - r.left) / r.width, 0, 1), ry = clamp((e.clientY - r.top) / r.height, 0, 1);
      setZoom(z.s, -(z.s - 1) * r.width * rx, -(z.s - 1) * r.height * ry);
    }

    /* ---------- Glisser vers le bas pour fermer (téléphone) --------- */
    function dragDismiss(dy) {
      var d = Math.max(0, dy);
      card.style.transition = 'none';
      scrim.style.transition = 'none';
      card.style.transform = 'translate3d(0,' + d + 'px,0) scale(' + (1 - Math.min(d / 1800, .08)) + ')';
      scrim.style.opacity = String(1 - Math.min(d / 420, .75));
    }
    function springBack() {
      card.style.transition = 'transform .4s ' + EASE;
      scrim.style.transition = 'opacity .4s ease';
      card.style.transform = '';
      scrim.style.opacity = '';
      setTimeout(function () { card.style.transition = ''; scrim.style.transition = ''; }, 420);
    }

    /* ---------- Ouvrir / fermer ------------------------------------- */
    function galleryImg(n) { return gSlides[n] ? q('img', gSlides[n]) : null; }
    function galleryIndex() {
      var gt = q('.g-track', main);
      if (gt) return clamp(Math.round(gt.scrollLeft / Math.max(1, gt.clientWidth)), 0, items.length - 1);
      return Math.max(0, gSlides.findIndex(function (s) { return s.classList.contains('active'); }));
    }
    function syncGallery(n) {
      var gt = q('.g-track', main);
      if (gt) { gt.scrollTo({ left: n * gt.clientWidth, behavior: 'auto' }); return; }
      gSlides.forEach(function (s, k) { s.classList.toggle('active', k === n); });
      qa('[data-gal-dot]', main).forEach(function (d, k) { d.classList.toggle('active', k === n); });
    }
    function lock(on) {
      var de = document.documentElement;
      if (on) {
        var sbw = window.innerWidth - de.clientWidth;
        de.style.setProperty('--pc-lb-sbw', (sbw > 0 ? sbw : 0) + 'px');
        de.classList.add('pc-lb-lock');
      } else {
        de.classList.remove('pc-lb-lock');
      }
    }
    function setInert(on) {
      if (on) {
        inerted = [];
        Array.prototype.forEach.call(document.body.children, function (c) {
          if (c === root || c.inert || /^(SCRIPT|STYLE|LINK)$/.test(c.tagName)) return;
          /* Un calque système posé au-dessus de tout reste utilisable : le
             bandeau cookies de Shopify (#shopify-pc__banner, z-index
             2 000 000) doit pouvoir recevoir un clic, popup ouvert ou non. */
          var cs = getComputedStyle(c);
          if (cs.position === 'fixed' && (parseInt(cs.zIndex, 10) || 0) > 1000) return;
          c.inert = true;
          inerted.push(c);
        });
      } else {
        inerted.forEach(function (c) { c.inert = false; });
        inerted = [];
      }
    }
    function stopAnims(el) {
      if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); });
    }
    function focusIn() {
      try { track.focus({ preventScroll: true }); } catch (e) { track.focus(); }
    }

    function open(n) {
      if (isOpen) return;
      build();
      isOpen = true;
      lastFocus = document.activeElement;
      var src = galleryImg(n), from = src && src.getBoundingClientRect();

      lock(true);
      root.hidden = false;
      stopAnims(card); stopAnims(scrim);
      resize();
      go(n, true);
      setInert(true);
      try { history.pushState({ pcLightbox: 1 }, ''); pushed = true; } catch (e) { pushed = false; }

      var target = slides[n];
      if (REDUCED || !inView(from) || !(src.currentSrc || src.src)) {
        scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
        card.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
      } else {
        var to = target.el.getBoundingClientRect();
        target.el.classList.add('is-flying');
        scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 420, easing: 'ease-out' });
        card.animate([{ opacity: 0, transform: 'scale(.965)' }, { opacity: 1, transform: 'none' }],
          { duration: 440, delay: 50, easing: EASE, fill: 'backwards' });
        var g = fly(src.currentSrc || src.src, from, to, innerRadius(main), innerRadius(stage), 480);
        g.anim.finished.then(function () { return ready(target.img, 900); }).then(function () {
          target.el.classList.remove('is-flying');
          g.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, fill: 'forwards' })
            .finished.then(function () { g.el.remove(); });
        });
      }
      focusIn();
      setTimeout(function () { if (isOpen) slides.forEach(function (s, k) { load(k); }); }, 650);
    }

    function close(opt) {
      if (!isOpen) return;
      opt = opt || {};
      isOpen = false;
      var n = i, s = slides[n];
      resetZoom(false);
      syncGallery(n);                          /* la galerie revient sur la photo regardée */
      if (pushed && !opt.fromHistory) { pushed = false; history.back(); }
      pushed = false;

      var dest = galleryImg(n), to = dest && dest.getBoundingClientRect();
      var done = function () {
        root.hidden = true;
        stopAnims(card); stopAnims(scrim);
        card.style.cssText = '';
        scrim.style.cssText = '';
        root.classList.remove('is-dragging', 'is-zoomed', 'is-gesture', 'is-loupe');
        s.el.classList.remove('is-flying');
        setInert(false);
        lock(false);
        if (lastFocus && lastFocus.focus && document.contains(lastFocus)) {
          try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* rien */ }
        }
      };

      if (opt.dy) {                            /* glissé vers le bas : on prolonge le geste */
        var t0 = card.style.transform || 'none';
        card.style.transition = 'none';
        card.animate([{ transform: t0, opacity: 1 }, { transform: 'translate3d(0,' + Math.round(window.innerHeight * .55) + 'px,0) scale(.9)', opacity: 0 }],
          { duration: 300, easing: 'cubic-bezier(.3,0,.8,.3)', fill: 'forwards' });
        scrim.animate([{ opacity: getComputedStyle(scrim).opacity }, { opacity: 0 }], { duration: 320, fill: 'forwards' })
          .finished.then(done);
        return;
      }
      if (REDUCED || !inView(to) || !s.img.naturalWidth) {
        card.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, fill: 'forwards' });
        scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, fill: 'forwards' }).finished.then(done);
        return;
      }
      var from = s.el.getBoundingClientRect();
      s.el.classList.add('is-flying');
      var g = fly(s.img.currentSrc || s.img.src, from, to, innerRadius(stage), innerRadius(main), 440);
      card.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.97)' }], { duration: 240, easing: 'ease-in', fill: 'forwards' });
      scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 380, easing: 'ease-in-out', fill: 'forwards' });
      g.anim.finished.then(function () {
        done();
        g.el.remove();
      });
    }

    /* ---------- Écouteurs du popup ---------------------------------- */
    function bind() {
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) close();
        else if (e.target.closest('[data-lb-prev]')) go(i - 1);
        else if (e.target.closest('[data-lb-next]')) go(i + 1);
      });

      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(current()); });
      }, { passive: true });

      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
        else if (e.key === 'Home') { e.preventDefault(); go(0); }
        else if (e.key === 'End') { e.preventDefault(); go(slides.length - 1); }
        else if (e.key === 'Tab') {
          var f = qa('button:not([disabled])', root).filter(function (b) { return b.offsetParent !== null; });
          if (!f.length) return;
          var k = f.indexOf(document.activeElement);
          if (e.shiftKey && k <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && (k === -1 || k === f.length - 1)) { e.preventDefault(); f[0].focus(); }
        }
      });

      window.addEventListener('popstate', function () { if (isOpen) close({ fromHistory: true }); });
      window.addEventListener('resize', function () {
        if (!isOpen) return;
        resetZoom(false);
        resize();
        go(i, true);
      });

      /* Molette verticale → photo suivante, UNE par geste (l'inertie
         d'un pavé tactile envoie des dizaines d'événements). Le geste
         horizontal du pavé, lui, fait défiler nativement. */
      var wheelAt = 0, wheelArmed = true, wheelAcc = 0;
      stage.addEventListener('wheel', function (e) {
        if (z.s > 1.01) { e.preventDefault(); return; }
        if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
        e.preventDefault();
        var now = Date.now();
        if (now - wheelAt > 220) { wheelArmed = true; wheelAcc = 0; }
        wheelAt = now;
        if (!wheelArmed) return;
        wheelAcc += e.deltaY;
        if (Math.abs(wheelAcc) > 24) { wheelArmed = false; go(i + (wheelAcc > 0 ? 1 : -1)); }
      }, { passive: false });

      /* Souris : glisser = photo suivante ; clic = loupe. */
      var md = null;
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;
        md = { x: e.clientX, left: track.scrollLeft, from: i, moved: false, id: e.pointerId };
      });
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (z.slide && z.loupe) { loupe(e); return; }
        if (!md || z.slide) return;
        var dx = e.clientX - md.x;
        if (!md.moved && Math.abs(dx) > 6) {
          md.moved = true;
          root.classList.add('is-dragging');
          try { stage.setPointerCapture(md.id); } catch (err) { /* rien */ }
        }
        if (md.moved) track.scrollLeft = md.left - dx;
      });
      var mouseUp = function (e) {
        if (!md) return;
        var m = md;
        md = null;
        if (m.moved) {
          root.classList.remove('is-dragging');
          var dx = e.clientX - m.x;
          go(Math.abs(dx) > 44 ? m.from + (dx < 0 ? 1 : -1) : m.from);
          return;
        }
        if (e.type !== 'pointerup') return;
        var sl = slideAt(e.target);
        if (!sl) return;
        if (z.slide) resetZoom(true); else zoomAt(sl, e.clientX, e.clientY, ZOOM_MOUSE, true);
      };
      stage.addEventListener('pointerup', mouseUp);
      stage.addEventListener('pointercancel', mouseUp);

      /* Doigts : double toucher, pincement, déplacement dans la photo
         zoomée, glisser vers le bas pour fermer. */
      var t = null, pinch = null, lastTap = null;
      root.addEventListener('gesturestart', function (e) { e.preventDefault(); }); /* Safari : pas de zoom de page */

      stage.addEventListener('touchstart', function (e) {
        if (e.target.closest('button')) { t = null; return; }
        if (e.touches.length === 2) {
          var a = e.touches[0], b = e.touches[1];
          var sl = z.slide || slideAt(a.target) || slides[i];
          if (z.slide !== sl) { resetZoom(false); z.slide = sl; z.loupe = false; }
          var r = sl.el.getBoundingClientRect();
          var mx = (a.clientX + b.clientX) / 2 - r.left, my = (a.clientY + b.clientY) / 2 - r.top;
          pinch = { d0: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1, s0: z.s,
                    ux: (mx - z.x) / z.s, uy: (my - z.y) / z.s, r: r };
          root.classList.add('is-gesture', 'is-zoomed');
          t = null; lastTap = null;
          return;
        }
        if (e.touches.length !== 1) return;
        var p = e.touches[0], now = Date.now();
        if (lastTap && now - lastTap.t < 320 && Math.hypot(p.clientX - lastTap.x, p.clientY - lastTap.y) < 30) {
          e.preventDefault();
          lastTap = null; t = null;
          if (z.slide) { resetZoom(true); return; }
          var target = slideAt(e.target);
          if (target) zoomAt(target, p.clientX, p.clientY, ZOOM_TAP, false);
          return;
        }
        lastTap = { t: now, x: p.clientX, y: p.clientY };
        t = { x0: p.clientX, y0: p.clientY, t0: now, mode: z.slide ? 'pan' : null, zx: z.x, zy: z.y };
        if (t.mode === 'pan') root.classList.add('is-gesture');
      }, { passive: false });

      stage.addEventListener('touchmove', function (e) {
        if (pinch) {
          if (e.touches.length < 2) return;
          e.preventDefault();
          var a = e.touches[0], b = e.touches[1];
          var s = clamp(pinch.s0 * Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) / pinch.d0, 1, ZOOM_MAX);
          var mx = (a.clientX + b.clientX) / 2 - pinch.r.left, my = (a.clientY + b.clientY) / 2 - pinch.r.top;
          setZoom(s, mx - pinch.ux * s, my - pinch.uy * s);
          return;
        }
        if (!t || e.touches.length !== 1) return;
        var p = e.touches[0], dx = p.clientX - t.x0, dy = p.clientY - t.y0;
        if (t.mode === 'pan') { e.preventDefault(); setZoom(z.s, t.zx + dx, t.zy + dy); return; }
        if (t.mode === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          lastTap = null;
          t.mode = dy > 0 && Math.abs(dy) > Math.abs(dx) * 1.2 ? 'dismiss' : 'native';
        }
        if (t.mode === 'dismiss') { e.preventDefault(); dragDismiss(dy); }
      }, { passive: false });

      var touchEnd = function (e) {
        if (pinch) {
          if (e.touches.length >= 2) return;
          pinch = null;
          root.classList.remove('is-gesture');
          if (z.s < 1.05) resetZoom(true);
          else {
            z.slide.img.sizes = sizesFor(z.s);
            if (e.touches.length === 1) {       /* un doigt reste posé : il déplace la photo */
              var p1 = e.touches[0];
              t = { x0: p1.clientX, y0: p1.clientY, t0: Date.now(), mode: 'pan', zx: z.x, zy: z.y };
              root.classList.add('is-gesture');
            }
          }
          return;
        }
        if (!t) return;
        var m = t;
        t = null;
        root.classList.remove('is-gesture');
        if (m.mode === 'dismiss') {
          var p = e.changedTouches[0], dy = p.clientY - m.y0, v = dy / Math.max(1, Date.now() - m.t0);
          if (dy > 110 || (dy > 40 && v > .55)) close({ dy: dy }); else springBack();
        }
      };
      stage.addEventListener('touchend', touchEnd);
      stage.addEventListener('touchcancel', touchEnd);
    }

    /* ---------- Galerie de la page : un simple toucher ouvre -------- */
    /* Un clic qui a glissé (galerie tirée à la souris) n'ouvre rien. */
    var down = null;
    main.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, true);
    main.addEventListener('click', function (e) {
      if (e.target.closest('button, a, [data-gal-dot]')) return;
      if (!e.target.closest('.g-track, .g-slide')) return;
      if (down && Math.hypot(e.clientX - down.x, e.clientY - down.y) > 8) return;
      open(galleryIndex());
    });
    main.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('g-track')) {
        e.preventDefault();
        open(galleryIndex());
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLightbox);
  else initLightbox();
})();
